import ChildrenAvatarStub from './ChildrenAvatarStub.vue';

export default ChildrenAvatarStub;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/avatar/components/stub/index.ts